<div class="prompt-library-list-container">
  @if (data()?.length) {
    <ul class="prompt-library-list" role="list">
      @for (libraryItem of data()!; track libraryItem.item.id) {
        <li
          class="prompt-library-list-item"
          [class.disabled]="isAutomationDisabled() || libraryItem.isDisabled"
          >
          <button
            type="button"
            class="item-run-btn"
            [matTooltip]="isAutomationDisabled() ? 'Automations are disabled while a Prompt, Instruction, or Workflow is running.' : (libraryItem.isDisabled ? 'This automation is disabled due to Sensitivity Label mismatch' : tooltipText() + libraryItem.item.details.name)"
            matTooltipPosition="right"
            (click)="runPrompt(libraryItem)"
            [disabled]="isAutomationDisabled() || libraryItem.isDisabled"
            aria-label="Run Automation">
            {{ truncateName(libraryItem.item.details.name) }}
          </button>
          <details class="actions-menu" (toggle)="onMenuToggle($event)">
            <summary aria-label="Automation Actions" matTooltip="Automation Actions" matTooltipPosition="below">
              <mat-icon class="material-symbols-outlined icon-sm icon-action" aria-hidden="true">more_horiz</mat-icon>
            </summary>
            <ul class="actions-list" role="menu" (click)="closeMenu($event)">
              @if (showEditAutomationButton(libraryItem)) {
                <li role="none">
                  <button type="button" role="menuitem" (click)="editPrompt(libraryItem)" aria-label="Edit Automation">
                    <mat-icon class="material-symbols-outlined icon-sm icon-action" aria-hidden="true">edit</mat-icon>
                    <span>Edit</span>
                  </button>
                </li>
              }
              <li role="none">
                <button type="button" role="menuitem" (click)="showPromptSummary(libraryItem)" aria-label="Automation Summary">
                  <mat-icon class="material-symbols-outlined icon-sm icon-action" aria-hidden="true">info</mat-icon>
                  <span>Summary</span>
                </button>
              </li>
            </ul>
          </details>
        </li>
      }
    </ul>
  } @else {
    <p class="empty-state">No Automation available. Add a new Automation to get started.</p>
  }
</div>
